module.exports = __webpack_public_path__ + "img/gallery-8.c84b18f8.jpg";